// Libs
import { createSelector } from 'reselect'

// Selectors
import getAllRequestsByStatus$ from './getAllRequestsByStatus'

// Constants
import { ERROR } from '../constants'

export default createSelector(
  getAllRequestsByStatus$(ERROR),
  (requests) => requests
)
